module.exports = __webpack_public_path__ + "static/media/Port Clearance Quick Start Guide.b19f7c8d.pdf";